import { render, staticRenderFns } from "./companynotice.vue?vue&type=template&id=16f87b91&"
import script from "./companynotice.vue?vue&type=script&lang=js&"
export * from "./companynotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports